import { Action } from '..';
import { IngestState, VerificationState } from './ingestSlice';

export const cancellingVerification = (state: IngestState) => {
  if (state.verification == null) {
    return state;
  }
  state.verification.cancelling = true;
  return state;
};

export const discardVerification = (state: IngestState) => {
  state.verification = undefined;
  return state;
};

export const approveErrorsAndDupes = (
  state: IngestState,
  action: Action<{ approval: boolean }>,
) => {
  if (state.verification == null) {
    return state;
  }
  const { approval } = action.payload;
  state.verification.errorsAccepted = approval;
  return state;
};
